import SchoolLayout from "../../layout/school.vue"

const inforRoutes = [
	{
	    path: "/schoole_meals",
	    name: "schoole_meals",
	    meta: {
	        module: "schoole_meals",
	        backgroundColor: "#fff",
			mainCss:{
				width: "100%"
			}
	    },
	    component: () => import("@/views/schoole_meals/index")
	},
]


export default {
	path: "/schoole_meals",
	component: SchoolLayout,
	redirect: "/schoole_meals",
	name: "schoole_meals",
	children: [
		...inforRoutes,
	]
}
